
import React, { Component } from 'react';
import { Provider } from 'react-redux';
import PropTypes from 'prop-types';
import { MuiThemeProvider } from '@material-ui/core/styles';
import DateFnsUtils from 'material-ui-pickers/utils/date-fns-utils';
import MuiPickersUtilsProvider from 'material-ui-pickers/utils/MuiPickersUtilsProvider';
import CssBaseline from '@material-ui/core/CssBaseline';
import TeeTimeSearch from '../TeeTimesSearch';
import theme from './theme';

class App extends Component {
  static propTypes = {
    store: PropTypes.object
  }
  render() {
    const { store } = this.props;
    return (
      <React.Fragment>
        <CssBaseline />
        <Provider store={store}>
          <MuiPickersUtilsProvider utils={DateFnsUtils}>
            <MuiThemeProvider theme={theme}>
              <TeeTimeSearch />
            </MuiThemeProvider>
          </MuiPickersUtilsProvider>
        </Provider>
      </React.Fragment>
    );
  }
}

export default App;


// WEBPACK FOOTER //
// ./src/containers/App/App.js